/**
 * Unique identifiers for system email templates. Max length 100 chars.
 *
 * @see EmailTemplateEntity.systemSlug
 */
export enum EmailTemplateSystemSlug {
	INTERNAL_ORDER_LIST = 'internal_order_list',
	INVOICE_DETAIL = 'invoice_detail',
	ORDER_DETAIL = 'order_detail',
	VENDOR_QUOTE_REQUEST = 'vendor_quote_request',
	VENDOR_PURCHASE_ORDER = 'vendor_purchase_order',
	VENDOR_RECEIPT_ISSUE = 'vendor_receipt_issue',
	/**
	 * PD-13445 — Motor City Ice self-delivery proof-of-delivery email
	 * (order summary, signature, pre/post-stop photos, invoice PDF) sent
	 * to the customer after a trip stop is completed with delivered goods.
	 * Deliberately named "self" delivery to distinguish it from the future
	 * carrier-based delivery confirmation (tracking summary).
	 */
	SELF_DELIVERY_CONFIRMATION = 'self_delivery_confirmation',
	/**
	 * PD-14978 — daily payments digest for tenant staff: authorizations held
	 * but never captured, failed collections, refunds owed to customers, and
	 * what was collected. Sent to the tenant's invoice document-copy
	 * recipients at 7:30 AM, after the morning gateway reconciliation sweep.
	 */
	DAILY_PAYMENTS_DIGEST = 'daily_payments_digest',
	/**
	 * PD-15417 — the original one-email-per-alert sensor notification (opener,
	 * reminder, all-clear). No longer sent since PD-16196; the value stays
	 * because tenants may hold a stored template row under it.
	 */
	SENSOR_ALERT = 'sensor_alert',
	/**
	 * PD-16196 — consolidated sensor alert email: open problems grouped by
	 * merchandiser with client and address, sent when a problem is new or at
	 * its temperature reminder, and as the 7:00 AM daily summary.
	 */
	SENSOR_ALERT_SUMMARY = 'sensor_alert_summary',
	/**
	 * Customer AR statement (PD-13702 / PD-14045) — the email that carries the
	 * statement PDF. Mirrors the invoice email's layout so a customer who
	 * receives both sees one company: logo, "Statement" title, balance due,
	 * aging summary, remit-to details. The PDF stays the document of record.
	 */
	CUSTOMER_STATEMENT = 'customer_statement',
	/**
	 * PD-16674 — the email staff send from "Email payment link": a branded
	 * note with one button that opens the storefront page where the customer
	 * pays an invoice, or saves a card or bank account, without signing in.
	 */
	PAYMENT_LINK = 'payment_link',
}
